import * as _4 from 'lodash4';

interface IMobileWindow extends Window {
  ionic?: any;
}

export type IPlatform = 'desktop' | 'android' | 'ios';

export class PlatformUtility {
  static getPlatform(): IPlatform {
    if (_4.isUndefined((window as IMobileWindow).ionic)) {
      return 'desktop';
    }
    return (window as IMobileWindow).ionic.Platform.isAndroid() ? 'android' : 'ios';
  }

  static isIOS(): boolean {
    return this.getPlatform() === 'ios';
  }

  static isAndroid(): boolean {
    return this.getPlatform() === 'android';
  }

  static isDesktop(): boolean {
    return this.getPlatform() === 'desktop';
  }

  static isMobile(): boolean {
    return this.isAndroid() || this.isIOS();
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-platform/src/platform_utility.ts